export const getNonce = () => {
    const nonce = window?.blink?.nonce;
    return nonce && !nonce.startsWith('<!--#') ? nonce : '';
};
//# sourceMappingURL=nonce-utils.js.map